import { disputesActionTypes } from './disputes-action-types';
import { IDisputeItem } from '../tables/disputes/disputes-data';
import { IDisputeQueueItem } from '../tables/disputes/disputes-queue';
import { MRT_SortingState } from 'material-react-table';
import { ISelectorData } from '../../components/application/NewApplication';

export interface IActionPayload {
    from: string;
    to: string;
    requestFrom: string;
    requestTo: string;
    disputeDetailsCreatedFrom: string;
    disputeDetailsCreatedTo: string;
    createdFrom: string;
    createdTo: string;
    field: DateField;
    pageNumber: number;
    pageSize: number;
    disputeQueueCreatedFrom: string;
    disputeQueueCreatedTo: string;
}

export enum DateField {
    authorizationDate = 'authorizationDate',
    requestDate = 'requestDate',
    createdDate = 'createdDate',
    disputeDetailsCreatedDate = 'disputeDetailsCreatedDate',
    disputeQueueCreatedDate = 'disputeQueueCreatedDate',
}

export interface IDisputeLists {
    providers: ISelectorData[];
    statuses: ISelectorData[];
    types: ISelectorData[];
}

export interface IFetchQueueResponse {
    disputeQueues: {
        rows: IDisputeQueues[];
        totalItemCount: number;
        firstItemOnPage: number;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        isFirstPage: boolean;
        isLastPage: boolean;
        lastItemOnPage: number;
        pageCount: number;
        pageNumber: number;
        pageSize: number;
    }
}

export interface IAction {
    type: disputesActionTypes;
    // payload: IDisputeItem[] |
    //     IDisputeQueueItem |
    //     IActionPayload |
    //     boolean |
    //     string |
    //     MRT_SortingState |
    //     string[] |
    //     IDisputeLists |
    //     IFetchQueueResponse |
    //     { [key: string]: string[] };
		payload?: any;
    totalItemCount?: number;
}

export interface IDisputeQueues {
    id: string;
    name: string;
    recordsCount: number;
    errors: string;
    errorCount: number;
    createdOn: string;
    totalCount: number;
    loadedRecordsCount: number;
    processedRecordsCount: number;
    source: string | null;
    isPined: boolean;
    openItemsAlert: boolean;
    newItemsAlert: boolean;
    emailRecipient: string;
    provider: string;
    type: string;
    partnerId: string;
}

export interface IReportProvidersList {
    value: string;
    label: string;
    types: ISelectorData[];
}

export interface IDisputesPaginationData {
    firstItemOnPage: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    isFirstPage: boolean;
    isLastPage: boolean;
    lastItemOnPage: number;
    pageCount: number;
    pageNumber: number;
    pageSize: number;
    totalItemCount: number;
    isCountEstimated: boolean;
    rows: IDisputeQueueItem[];
}

export interface IState {
    disputes: IDisputeItem[] | IDisputeQueueItem[];
    disputeDetails: IDisputeQueueItem;
    isDisputeDetailsLoading: boolean;
    isDisputesLoading: boolean;
    isDisputesExportLoading: boolean;
    query: string;
    sort: string;
    pageNumber: number;
    pageSize: number;
    from: string;
    to: string;
    disputeDetailsCreatedFrom: string;
    disputeDetailsCreatedTo: string;
    createdFrom: string;
    createdTo: string;
    requestFrom: string;
    requestTo: string;
    timezone: string;
    sorting: MRT_SortingState;
    totalItemCount: number;
    managementSystem: string[] | null;
    kountStatusCodes: { [key: string]: string[] };
    cardBrands: string[] | null;
    selectedProviderName: string[];
    selectedCardBrand: string[];
    selectedDisputeType: string[];
    isWebhook: string;
    isFileImported: string;
    isManualInserted: string;
    isDisputeMatchLoading: boolean;
    isKountAlertLoading: boolean;
    disputeDetailsLists: IDisputeLists;
    isArchivatingDisputeLoading: boolean;
    disputeQueues: IDisputeQueues[];
    isDisputeQueuesLoading: boolean;
    isProviderName: boolean;

    disputeQueueTotalItemCount: number;
    disputeQueueTimezone: string;

    kountEventType?: string;
    reportProvidersList: IReportProvidersList[];
    isReportProviderListLoading: boolean;
}
